import { SaaSDestination } from "@/destinations/destinations";

function needsOAuth(destination: SaaSDestination): boolean {
  return destination.configFields.some(
    (field) => field.type === "oauth" || field.key === "oauthToken",
  );
}

/**
 * Why a destination must be set up on its own page instead of in the wizard,
 * or null when the wizard can set it up. The wizard only renders plain config
 * fields, so OAuth flows and custom config pages would save a partial config.
 */
export function getSetupPageReason(
  destination: SaaSDestination,
  { isHipaaV2 }: { isHipaaV2: boolean },
): string | null {
  if (!destination.supportsTrack) {
    return "Doesn’t receive events. Set it up on its page.";
  }
  if (destination.customConfig || needsOAuth(destination)) {
    return "Needs extra setup on its page.";
  }
  if (isHipaaV2 && !destination.supportsServerSide) {
    return "Client-side only, so HIPAA mode needs a BAA. Set it up on its page.";
  }
  return null;
}
